import {
	fetchNextSortition,
	fetchPrizes,
	fetchResults,
	fetchDisplaySortitions,
	fetchCardResults,
	requestFetchDisplayResults
} from '@/api/homepage.api';
import keyBy from 'lodash/keyBy.js';

const contentStatus = {
	loading: 'loading',
	loaded: 'loaded',
	error: 'error'
};

const MAX_ATTEMPTS = 20;

let refreshResultsInterval = null;
let refreshCardInterval = null;

export default {
	provide() {
		return {
			contentStatus: this.contentStatus
		};
	},
	data() {
		return {
			contentStatus,
			upcomingSortition: {
				status: contentStatus.loading,
				sortition: null
			},
			results: {
				status: contentStatus.loading,
				entries: []
			},
			prizes: {
				status: contentStatus.loading,
				entries: []
			},
			cardResults: {},
			displaySortitions: [],
			timeouts: [],
			currentPage: -1,
			pageInterval: null,
			showCardInterval: false,
			showPrizes: true,
			showResults: false,
			showNResults: 4
		};
	},
	computed: {
		resultsToShow() {
			return keyBy(this.cardPages[this.currentPage], 'lottery_id');
		},
		cardPages() {
			const resultObjects = Object.values(this.cardResults),
				acc = [],
				result = [];

			resultObjects.forEach((sr, index) => {
				if (acc.flatMap(x => x.results).length < this.showNResults) {
					acc.push(sr);
					if (index === resultObjects.length - 1) {
						result.push(acc);
					}
				} else if (index === resultObjects.length - 1) {
					result.push(acc.splice(0, acc.length));
					acc.push(sr);
					result.push(acc.splice(0, acc.length));
				} else {
					result.push(acc.splice(0, acc.length));
					acc.push(sr);
				}
			});

			return result;
		},
		pageLength() {
			return this.cardPages.length;
		},
		url() {
			return window.location.host;
		}
	},
	created() {
		this.fetchUpcomingSortition();

		const refreshResultsEvery15Minutes = 900000;
		refreshResultsInterval = setInterval(
			() => this.fetchLastResults(),
			refreshResultsEvery15Minutes
		);
		refreshCardInterval = setInterval(
			() => this.fetchCardResults(),
			refreshResultsEvery15Minutes
		);
		this.fetchLastResults();
		this.fetchCardResults();
		fetchPrizes()
			.then(async response => {
				this.prizes.entries = response.data.prizes;
				await this.$nextTick();
				this.prizes.status = contentStatus.loaded;
			})
			.catch(() => {
				this.prizes.status = contentStatus.error;
			});
		fetchDisplaySortitions().then(response => {
			this.displaySortitions = response.data.sortitions.map(x => ({
				...x,
				attempts: 0 // Max 10 attempts
			}));
			this.displaySortitions.forEach(s => {
				if (s.timeLeftMillis > 0) {
					const timeout = setTimeout(() => {
						console.log('Fetching results for sortition: ', s.name);
						this.fetchDisplayResult(s.sortitionId);
					}, s.timeLeftMillis);
					this.timeouts.push(timeout);
				}
			});
		});
	},
	destroyed() {
		clearInterval(refreshResultsInterval);
		clearInterval(refreshCardInterval);
		clearInterval(this.pageInterval);
		clearInterval(this.showCardInterval);
		this.timeouts.forEach(t => {
			clearTimeout(t);
		});
	},
	methods: {
		fetchLastResults() {
			fetchResults()
				.then(async response => {
					this.results.entries = response.data.results;
					await this.$nextTick();
					this.results.status = contentStatus.loaded;
				})
				.catch(() => {
					this.results.status = contentStatus.error;
				});
		},
		fetchDisplayResult(sortitionId) {
			const currentSortition = this.displaySortitions.find(
				s => s.sortitionId === sortitionId
			);

			requestFetchDisplayResults(currentSortition.sortitionId)
				.then(response => {
					const result = response.data.result;
					if (result) {
						console.log('Result found.');
						this.$emit('show-result', result);
					} else {
						if (currentSortition.attempts <= MAX_ATTEMPTS) {
							console.log('Result not found, retrying in 1 minute.');
							setTimeout(() => {
								this.fetchDisplayResult(sortitionId);
							}, 60000);
						} else {
							console.log('Result not found, max attempts reached.');
						}
					}
				})
				.catch(() => {
					if (currentSortition <= MAX_ATTEMPTS) {
						console.log('An error occurred, retrying in 1 minute.');
						setTimeout(() => {
							this.fetchDisplayResult(sortitionId);
						}, 60000);
					} else {
						console.log('An error occurred, max attempts reached.');
					}
				})
				.finally(() => {
					console.log('Attempts: ', currentSortition.attempts);
					currentSortition.attempts += 1;
				});
		},
		fetchUpcomingSortition() {
			this.upcomingSortition.status = contentStatus.loading;
			fetchNextSortition().then(async response => {
				this.upcomingSortition.sortition = response.data.sortition;
				await this.$nextTick();
				this.upcomingSortition.status = contentStatus.loaded;
			});
		},
		fetchCardResults() {
			fetchCardResults().then(response => {
				this.cardResults = response.data.resultsByLottery;
			});
		}
	},
	watch: {
		cardResults() {
			if (this.pageInterval) {
				clearInterval(this.pageInterval);
			}
			this.pageInterval = setInterval(() => {
				if (this.currentPage === this.pageLength - 1) {
					this.currentPage = -1;
					this.showResults = false;
					this.showPrizes = true;
				} else {
					this.currentPage += 1;
					this.showResults = true;
					this.showPrizes = false;
				}
				console.log(this.currentPage);
			}, 30000);
		}
	}
};
